import React, { useState } from "react";
import logo from "./logo.png";
import { Link } from "react-router-dom";
import { useAuth } from "../../Context/useAuth";

interface Props {}

const Navbar = (props: Props) => {
  const { isLoggedIn, user, logOut } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header>
      {/* Centred Version Banner */}
      <div className="w-full bg-gray-50 text-gray-500 text-xs py-1 text-center border-b">
        Version: {process.env.REACT_APP_BUILD_DATE || "Dev Build"}
      </div>

      <nav className="relative container mx-auto p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-20">
            <Link to="/">
              <img src={logo} alt="Logo" />
            </Link>
            <div className="hidden font-bold lg:flex">
              <Link to="/search" className="text-black hover:text-darkBlue">
                Search
              </Link>
            </div>
            <div className="hidden font-bold lg:flex">
              <Link to="/todo" className="text-black hover:text-darkBlue">
                Dev's To-Do List
              </Link>
            </div>
            {isLoggedIn() ? (
              <div className="hidden font-bold lg:flex items-center space-x-6">
                {/* not interactive -> keep arrow cursor */}
                <div className="hover:text-darkBlue cursor-default">Welcome, {user?.userName}</div>
                {/* action -> use button + pointer cursor for accessibility */}
                <button
                  type="button"
                  onClick={logOut}
                  className="px-8 py-3 font-bold rounded text-white bg-lightGreen hover:opacity-70 cursor-pointer"
                >
                  Logout
                </button>
              </div>
            ) : (
              <div>
                <div className="hidden font-bold lg:flex items-center space-x-6">
                  <Link to="/login" className="text-black hover:text-darkBlue">
                    Login
                  </Link>
                  <a
                    href="/register"
                    className="px-8 py-3 font-bold rounded text-white bg-lightGreen hover:opacity-70"
                  >
                    Signup
                  </a>
                </div>
              </div>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button className="block lg:hidden text-4xl" onClick={() => setIsOpen(!isOpen)}>
            ☰
          </button>
        </div>

        {/* Mobile Dropdown */}
        {isOpen && (
          <div className="flex flex-col items-center mt-4 space-y-4 lg:hidden">
            <Link to="/search" className="text-black hover:text-darkBlue">
              Search
            </Link>
            <Link to="/todo" className="text-black hover:text-darkBlue">
              Dev's To-Do List
            </Link>
            {!isLoggedIn() ? (
              <div className="flex flex-col items-center mt-4 space-y-4 lg:hidden w-full">
                <Link to="/login" className="text-black hover:text-darkBlue">
                  Login
                </Link>
                <a
                  href="/register"
                  className="px-8 py-3 font-bold rounded text-white bg-lightGreen hover:opacity-70"
                >
                  Signup
                </a>
              </div>
            ) : (
              <div className="flex flex-col items-center mt-4 space-y-4 lg:hidden w-full">
                <div className="hover:text-darkBlue cursor-default">Welcome, {user?.userName}</div>
                <button
                  type="button"
                  onClick={logOut}
                  className="px-8 py-3 font-bold rounded text-white bg-lightGreen hover:opacity-70 cursor-pointer"
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        )}
      </nav>
    </header>
  );
};

export default Navbar;
